const formatNumberWithComma = num => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

const formatNumberToDollar = num => {
  return '$'.concat(num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
};

export { formatNumberWithComma, formatNumberToDollar };
